import { ApplicationTypes } from 'jms-domain'

import { isDeselectUpdate } from '@salsita-ai/platform-project-sdk/domain'

import { configuratorInterface } from '../systems/configurator-interface'

// When user deselects the room (clicks inside the scene) on the Recipes tab,
// navigate to the RoomContent tab.
export const onDeselectRoomTransformer = configuratorInterface.createTransformer(ctx => (updates, state) => {
  const activeNavigationState = ctx.navigationSystem.getActiveNavigationState(state)
  if (activeNavigationState !== ApplicationTypes.NavigationState.Recipes) {
    return updates
  }

  const roomDeselectUpdate = updates.find(
    u => isDeselectUpdate(u) && u.writableState.selectedEntityId === state.rootEntityId
  )

  if (!roomDeselectUpdate) {
    return updates
  }

  return [ctx.navigationSystem.getNavigationUpdate(ApplicationTypes.NavigationState.RoomContent)]
})
